var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.04 62.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#1c3152;}.cls-5{clip-path:url(#clip-path-3);}.cls-6{fill:#39af4f;}.cls-7{clip-path:url(#clip-path-4);}.cls-8{clip-path:url(#clip-path-5);}.cls-9{clip-path:url(#clip-path-6);}.cls-10{clip-path:url(#clip-path-7);}.cls-11{clip-path:url(#clip-path-8);}.cls-12{clip-path:url(#clip-path-9);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 125.04,
    height: 62.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.54,35.89A13.18,13.18,0,0,0,1.73,51.1a13.31,13.31,0,0,0,13,11A17,17,0,0,0,20.46,61a.5.5,0,0,0,.4-.56q0-3.45,0-6.88v-.47a8.67,8.67,0,0,1-3.49,2.32,6.91,6.91,0,0,1-4,.09,6.58,6.58,0,0,1-3.4-2.26,7.31,7.31,0,0,1,.55-9.54,7.12,7.12,0,0,1,10.39.86c0-2.6,0-5.1,0-7.6a.4.4,0,0,0-.23-.28,15.19,15.19,0,0,0-5.79-1.22,13.34,13.34,0,0,0-3.28.41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119,22.85c-3.18,4.92-7.91,7.22-13.59,7.68-1.71.14-3.43.12-5.15.1h-3c.17.19.25.3.35.39A14.82,14.82,0,0,0,108,35.53c3.28.1,6.57.08,9.85.06h4.33a1.36,1.36,0,0,0,1.34-.89,1.38,1.38,0,0,0-.36-1.64l-1.94-1.85c-.41-.39-.41-.39-.06-.82a10.06,10.06,0,0,0,1-11.79A16.94,16.94,0,0,0,121,16.82a16.77,16.77,0,0,1-2,6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.78,20.18a1.51,1.51,0,1,1,0-3h8.93a1.51,1.51,0,1,1,0,3H96.78m13-7a1.5,1.5,0,0,1,.47,2.93,1.7,1.7,0,0,1-.45.08c-4.41,0-8.81,0-13.22,0a1.48,1.48,0,0,1-1.44-1.28,1.5,1.5,0,0,1,.9-1.6,2,2,0,0,1,.73-.12h13m-9.37-8.56a14.35,14.35,0,0,0-8.33,4.4,10,10,0,0,0-2.12,11,10,10,0,0,0,1.87,3c-.72.8-1.36,1.57-2.06,2.3a1.52,1.52,0,0,0-.5,1.76,1.44,1.44,0,0,0,1.54.9c4.24,0,8.48,0,12.71,0a20.63,20.63,0,0,0,2.84-.18,15.08,15.08,0,0,0,8.86-4.35,10.23,10.23,0,0,0,1.88-11.95A12.6,12.6,0,0,0,111,5.92a16.81,16.81,0,0,0-7.15-1.57,19,19,0,0,0-3.41.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.25,36.18c-1.9,0-3.8,0-5.71,0h-.43v9.69H32.62V36.21H26.11v25.2h6.53V51.05h9.49V61.39h6.53c0-.15,0-.27,0-.39q0-12.2,0-24.37c0-.34-.08-.45-.42-.45h0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.71,43.82h.1c1,2.72,1.9,5.44,2.87,8.2H61.83l2.88-8.19m-3-7.64a.59.59,0,0,0-.67.47q-4.22,11.1-8.44,22.19c-.33.84-.64,1.68-1,2.55l.21,0h6.5c.23,0,.31-.1.38-.3.42-1.24.86-2.48,1.27-3.72a.44.44,0,0,1,.5-.37h8.64a.43.43,0,0,1,.49.37c.41,1.21.84,2.4,1.23,3.61a.51.51,0,0,0,.59.41c1.19,0,2.38,0,3.57,0h3c-.06-.18-.1-.32-.15-.46Q73.13,48.77,68.5,36.58a.51.51,0,0,0-.57-.4c-2.08,0-4.17,0-6.25,0h0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.26,18.77a13.18,13.18,0,0,1,3.49.28,3.57,3.57,0,0,1,2.8,3.39,3.52,3.52,0,0,1-2.62,3.64,5.23,5.23,0,0,1-1.1.22c-1.11.05-2.21.05-3.31.07l-.35,0V18.77h1.09m-1.1-3.19V8.25c1.41,0,2.81-.15,4,.72a2.77,2.77,0,0,1,1.08,1.6,4.81,4.81,0,0,1-.16,3.09,2.69,2.69,0,0,1-1.53,1.52,6.63,6.63,0,0,1-2.65.4h-.77M65.59,4.73l-.22,0V30h.48c1.86,0,3.72,0,5.58,0a22.58,22.58,0,0,0,3.08-.26,7.07,7.07,0,0,0,4.81-10.64A6,6,0,0,0,76,16.4c.31-.37.6-.67.85-1a6.53,6.53,0,0,0,.64-1.08,6.81,6.81,0,0,0-5.7-9.42c-2.07-.16-4.16-.12-6.24-.16h0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.62,4.75c0,.15,0,.28,0,.4,0,5.37,0,10.74,0,16.11a10.26,10.26,0,0,0,.31,2.4,9.34,9.34,0,0,0,13.44,5.71A8.83,8.83,0,0,0,59.29,21c0-5.25,0-10.49,0-15.73V4.76H55.47v.53q0,7.26,0,14.51a18.43,18.43,0,0,1-.09,2,5.77,5.77,0,0,1-1,2.94,5.29,5.29,0,0,1-5.46,2.06,4.68,4.68,0,0,1-4.13-3.64,11.91,11.91,0,0,1-.37-2.85c0-5,0-10,0-15V4.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.25,8.51a13.42,13.42,0,0,0-3.44,9v.05a12.82,12.82,0,0,0,4,9.38A13.4,13.4,0,0,0,21.48,28.7a.57.57,0,0,0,.22-.42c0-.58,0-1.15,0-1.72V24a9.45,9.45,0,0,1-13.93-.44A10,10,0,0,1,8,11c3-3.53,8.77-4.61,13.73-.4,0-1.48,0-2.89,0-4.3,0-.12-.15-.28-.27-.35A12.83,12.83,0,0,0,15,4.25,13.08,13.08,0,0,0,5.25,8.51"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -3.48,
    y: 30.48,
    width: 29.34,
    height: 36.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 92.25,
    y: 11.82,
    width: 36.43,
    height: 28.79
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 84.18,
    y: -0.65,
    width: 39.1,
    height: 33.69
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.11,
    y: 31.18,
    width: 32.58,
    height: 35.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 46.58,
    y: 31.18,
    width: 36.35,
    height: 35.25
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "77.39 36.22 77.39 41.77 82.76 41.77 82.76 61.38 89.3 61.38 89.3 41.76 94.65 41.76 94.65 36.22 77.39 36.22"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 60.37,
    y: -0.27,
    width: 24.98,
    height: 35.24
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 35.6,
    y: -0.25,
    width: 28.7,
    height: 35.71
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -3.19,
    y: -0.75,
    width: 29.9,
    height: 36.17
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "26.54 4.75 26.54 29.93 37.71 29.93 37.71 26.35 30.32 26.35 30.32 4.75 26.54 4.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.2db0de676757f2a7b23a5a4a70d55eef.svg";
export { ForwardRef as ReactComponent };